import type { FaireProductEntity } from "../../entity_types/product";

export const p_3cjz3mgb3a: FaireProductEntity = {
  token: "p_3cjz3mgb3a",
  type: "product",
  name: "Oval Metal Small Hair Claw Clip with Sparkling Rhinestones",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/cc2ec67e8dfdf3eec4ad1b508e571af06062c3076b918baf7595a239aae4a522.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14484eef8072d878fde786e2c9f5bfce9e28f97d34d1dee394805512b416ec5a.jpeg",
    "https://cdn.faire.com/fastly/cb39f436f1d9482acededf6c0908d26c36ce74779bf49591db479e51a12d334e.jpeg",
    "https://cdn.faire.com/fastly/d9a47fc6e399483b0c327237d204489acb487a6ea4588115b85eb76d279ce681.jpeg",
    "https://cdn.faire.com/fastly/b3dfc1dcabc2ad45896a4f5d15ad01a33b57c42e46da39eb182365c139ffdada.jpeg",
    "https://cdn.faire.com/fastly/6618e3cf60183e990e8d70e2118669d74e03e7a086dacb30f79cf1dc30464faa.jpeg",
    "https://cdn.faire.com/fastly/d1b6e72ba45a8f7678d3b5461c99010cf41b0bae68362d89a11f1d8df633d5ff.jpeg",
  ],
  priceDollars: 2.42,
  description:
    "Size: 3cm\nWeight: 13g\nMaterial: Alloy, Rhinestones\n\nAdd a touch of elegance to your hairstyle with this oval metal mini hair claw clip adorned with sparkling rhinestones. Its compact design makes it perfect for securing small sections of hair or adding a chic accent to any look. The durable metal construction ensures a firm hold, while the rhinestones catch the light beautifully for a subtle shimmer. Ideal for everyday wear, office settings, or special occasions, this mini claw clip combines functionality with stylish sophistication.",
  tags: [],
  msrpDollars: 4.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:40.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
